import { render, staticRenderFns } from "./point_control.vue?vue&type=template&id=adc1e1f8&"
import script from "./point_control.vue?vue&type=script&lang=js&"
export * from "./point_control.vue?vue&type=script&lang=js&"
import style0 from "./point_control.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports